module.exports = "<img :src=getIconUrl :class=getCustomClass :style=getCustomStyle alt=omnicasa-icon />";